'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var baseFonts = exports.baseFonts = {
  fontFamily: '-apple-system, ".SFNSText-Regular", "San Francisco", BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Lucida Grande", "Arial", sans-serif',
  color: '#444',
  WebkitFontSmoothing: 'antialiased'
};

var monoFonts = exports.monoFonts = {
  fontFamily: '"Operator Mono", "Fira Code Retina", "Fira Code", "FiraCode-Retina", "Andale Mono", "Lucida Console", Consolas, Monaco, monospace',
  color: '#444',
  WebkitFontSmoothing: 'antialiased'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/components/dist/theme.js
 ** module id = 323
 ** module chunks = 0
 **/